function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M28.9042 2.44227C30.8611 4.10766 31.9019 6.23104 32.0268 8.81241C32.1517 11.3938 31.3191 13.5796 29.5288 15.3699L17.4755 27.8604C17.0591 28.2767 16.5803 28.4849 16.0391 28.4849C15.4978 28.4849 15.019 28.2767 14.6027 27.8604L2.54937 15.3699C0.759074 13.5796 -0.0736231 11.3938 0.0512814 8.81241C0.176186 6.23104 1.21706 4.10766 3.17389 2.44227C4.88092 0.985045 6.83776 0.360521 9.04441 0.568696C11.2927 0.735235 13.2079 1.63039 14.79 3.25415L16.0391 4.50319L17.2881 3.25415C18.8702 1.63039 20.7646 0.735235 22.9713 0.568696C25.2195 0.360521 27.1972 0.985045 28.9042 2.44227Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartSolid);
export default __webpack_public_path__ + "static/media/heart_solid.83564dc2722f938cc3b2abc827f15dc3.svg";
export { ForwardRef as ReactComponent };